export function percentage(amount, from) {
    if (from === 0)
        return 0;
    return (amount / from) * 100;
}
